<template v-if="tab === 'soundboard'">
  <li class="headline">
    {{ t('menu.tabs.soundboard') }}
  </li>
  <li @click="soundboard.playSound({ sound: 'ringing' })">
    {{ t('sound.ringing') }}
    <em>[B]</em>
  </li>
  <li @click="soundboard.playSound({ sound: 'rooster' })">
    {{ t('sound.rooster') }}
    <em>[D]</em>
  </li>
  <li @click="soundboard.playSound({ sound: 'gavel' })">
    {{ t('sound.gavel') }}
    <em>[H]</em>
  </li>
  <li @click="soundboard.playSound({ sound: 'death' })">
    {{ t('sound.death') }}
    <!-- maybe add a shortcut one day -->
  </li>
  <li @click="soundboard.playSound({ sound: 'drumRoll' })">
    {{ t('sound.drumRoll') }}
    <!-- maybe add a shortcut one day -->
  </li>
</template>

<script setup lang="ts">
import {
  useLocaleStore,
  useSoundboardStore,
} from "@/stores";

const locale = useLocaleStore();
const t = locale.t;
const soundboard = useSoundboardStore();
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
